import { motion } from 'framer-motion'
import SectionWrapper from '../layout/SectionWrapper'

const rituals = [
  {
    emoji: '🍎',
    title: 'Cueillette de Pommes',
    description: 'Nos aventures automnales dans les vergers'
  },
  {
    emoji: '🥞',
    title: 'Brunchs du Dimanche',
    description: 'Notre tradition hebdomadaire préférée'
  },
  {
    emoji: '🍽️',
    title: 'Restaurants',
    description: 'Découvrir de nouvelles saveurs ensemble'
  }
]

export default function AutomneSection() {
  return (
    <SectionWrapper
      id="automne"
      gradient="from-dark-secondary via-dark-primary to-dark-secondary"
    >
      {/* Header */}
      <motion.div className="text-center mb-16">
        <motion.span
          className="tag-pill mb-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span>🍂</span>
          <span>Automne 2025</span>
        </motion.span>

        <motion.h2
          className="text-4xl md:text-6xl font-serif font-bold gradient-text mb-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
        >
          L'Automne & la Maturité
        </motion.h2>

        <motion.p
          className="text-lg text-light-pink-100/70"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
        >
          Notre relation grandit avec chaque saison
        </motion.p>
      </motion.div>

      {/* Rituals */}
      <div className="grid md:grid-cols-3 gap-6 mb-16">
        {rituals.map((ritual, index) => (
          <motion.div
            key={ritual.title}
            className="glass-card text-center"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.15 }}
            whileHover={{ y: -10, boxShadow: '0 20px 40px rgba(232, 81, 178, 0.15)' }}
          >
            <motion.div
              className="text-6xl mb-4"
              whileHover={{ rotate: [0, -10, 10, 0], scale: 1.1 }}
            >
              {ritual.emoji}
            </motion.div>
            <h3 className="text-xl font-bold text-white mb-2">{ritual.title}</h3>
            <p className="text-light-pink-100/70">{ritual.description}</p>
          </motion.div>
        ))}
      </div>

      {/* Inside Joke Section */}
      <motion.div
        className="max-w-2xl mx-auto"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
      >
        <motion.div
          className="glass-card pink-glow text-center py-8"
          whileHover={{ scale: 1.02 }}
        >
          <motion.span
            className="text-5xl block mb-4"
            animate={{ rotate: [0, 5, -5, 0] }}
            transition={{ duration: 2, repeat: Infinity }}
          >
            😂
          </motion.span>

          <h3 className="text-2xl font-serif font-bold text-white mb-2">
            Nos Inside Jokes
          </h3>

          <motion.div
            className="inline-block mt-4 px-6 py-3 bg-primary-pink/20 rounded-full"
            whileHover={{ scale: 1.05 }}
          >
            <span className="text-2xl font-bold gradient-text">
              "Viand Boeuf" 🥩
            </span>
          </motion.div>

          <p className="mt-4 text-light-pink-100/70 italic">
            Ces petits riens qui nous font rire et qui n'appartiennent qu'à nous
          </p>
        </motion.div>
      </motion.div>

      {/* Favorite Memory */}
      <motion.div
        className="mt-12 max-w-3xl mx-auto"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <div className="glass-card">
          <div className="flex items-start gap-4">
            <span className="text-4xl">🎓</span>
            <div>
              <h3 className="text-xl font-bold text-white mb-2">
                Mon Meilleur Souvenir
              </h3>
              <p className="text-light-pink-100/80">
                Ce moment ensemble à l'université, quand tu m'as montré ton monde académique.
                Te voir dans ton élément, passionnée et déterminée, m'a fait t'aimer encore plus.
              </p>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Quote */}
      <motion.blockquote
        className="text-center mt-16 max-w-2xl mx-auto"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <p className="text-xl md:text-2xl text-light-pink-100/80 italic font-serif leading-relaxed">
          "L'automne peint nos souvenirs en or
          <br />
          Cueillette de pommes, encore et encore"
        </p>
        <footer className="mt-4 text-primary-pink text-sm">
          — Verse 4
        </footer>
      </motion.blockquote>
    </SectionWrapper>
  )
}
